import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { WalletProvider } from "./contexts/WalletContext";
import { NotificationPreferencesProvider } from "./featured/User";
import { AccessProvider } from "./archive_project/context/AccessContext";

/**
 * Initialises and wraps every global context the app needs.
 *
 * The state itself lives inside the feature it belongs to; this file only
 * decides how those providers compose - the same division as src/routesConfig.jsx,
 * which owns route composition while the pages live in their blocks. Keeping it
 * here means src/index.js does not have to know any feature's wiring.
 *
 * The nesting order is load-bearing:
 *   - NotificationPreferencesProvider derives from the user object, so it must
 *     sit inside AuthProvider.
 *   - WalletProvider calls useAuth(), so it must too.
 */
export const AppProviders = ({ children }) => (
  <AuthProvider>
    <NotificationPreferencesProvider>
      <WalletProvider>
        <AccessProvider>{children}</AccessProvider>
      </WalletProvider>
    </NotificationPreferencesProvider>
  </AuthProvider>
);

export default AppProviders;
